import { render } from "./more-info.vue?vue&type=template&id=eea5eb8c&scoped=true&lang=pug"
import script from "./more-info.vue?vue&type=script&lang=js"
export * from "./more-info.vue?vue&type=script&lang=js"

import "./more-info.vue?vue&type=style&index=0&id=eea5eb8c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eea5eb8c"]])

export default __exports__